var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgWarningFeatured = function SvgWarningFeatured(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 40,
    fill: "none"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 20,
    r: 20,
    fill: "#FFF9E3"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#FFB800",
    fillRule: "evenodd",
    d: "M10.667 20A9.333 9.333 0 0 0 20 29.333 9.333 9.333 0 0 0 29.333 20 9.333 9.333 0 0 0 20 10.667 9.333 9.333 0 0 0 10.667 20ZM20 8C13.373 8 8 13.373 8 20s5.373 12 12 12 12-5.373 12-12S26.627 8 20 8Zm0 5.333c.736 0 1.333.597 1.333 1.333v6.667a1.333 1.333 0 0 1-2.666 0v-6.667c0-.736.597-1.333 1.333-1.333Zm0 13.334A1.333 1.333 0 1 0 20 24a1.333 1.333 0 0 0 0 2.667Z",
    clipRule: "evenodd"
  })));
};
export default SvgWarningFeatured;